import { Scanner } from "@yudiel/react-qr-scanner";

export default function TicketQRScanner({ onResult, onClose }) {
  return (
    <div style={{ marginTop: 10 }}>
      <Scanner
        constraints={{ facingMode: "environment" }}
        // CAMBIO CLAVE AQUÍ: Usar onScan en lugar de onDecode
        onScan={(results) => {
          // La librería ahora devuelve un ARRAY de resultados.
          // Debemos verificar si hay resultados y tomar el primero.
          if (results && results.length > 0) {
            const rawValue = results[0].rawValue; // En la v2 se llama 'rawValue', no 'text'
            
            if (rawValue) {
              onResult(rawValue);
            }
          }
        }}
        onError={(error) => {
          console.warn("QR error:", error);
        }}
        // Opcional: Desactivar el pitido si molesta, scanDelay, etc.
        // scanDelay={2000} 
        
        styles={{
          container: {
            width: "100%",
            maxWidth: "400px",
            margin: "0 auto",
          }
        }}
        // Nota: containerStyle a veces se pasa dentro de una prop 'styles' dependiendo la versión exacta,
        // pero la librería suele ser flexible con el div contenedor.
      />

      <button
        onClick={onClose}
        style={{
          marginTop: 10,
          width: "100%",
          padding: 10,
        }}
      >
        Cerrar escáner
      </button>
    </div>
  );
}



